import { render, staticRenderFns } from "./ViewListUser.vue?vue&type=template&id=720256bf&"
import script from "./ViewListUser.vue?vue&type=script&lang=js&"
export * from "./ViewListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports